//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"ArcAngle",1,0],[0,"ArcRadius",1,0],[0,"DeltaXC",1,0],[0,"DeltaYC",1,0],[0,"DeltaZC",1,0],[0,"ExtendDirection",1,"Axis",0],[0,"ExtendMethod",1,0],[0,"FirstLinearDistance",1,0],[0,"GougeCheckClearanceMethod",1,0],[0,"GougeCheckClearancePlane",1,"NXObject",0],[0,"HolderCheck",1,0],[0,"MotionMethod",1,0],[0,"MoveStartPoint",1,0],[0,"PermanentBoundary",1,"NXObject",0],[0,"ReferencePoint",1,"Point",0],[0,"SecondLinearDistance",1,0],[0,"ToPoint",1,"Point",0],[0,"TransformCircles",1,0],[0,"TrimClearanceMethod",1,0],[0,"TrimClearancePlane",1,"NXObject",0],[0,"TrimConnectionMethod",1,0],[0,"TrimDirection",1,"Axis",0],[0,"TrimGeometry",1,0],[0,"TrimLine",1,"NXObject",0],[0,"TrimPlane",1,"NXObject",0],[0,"TrimSide",1,0]],[[[],"Move",{},0,0],[[],"Extend",{},0,0],[[],"GougeCheck",{},0,0],[[],"SelectAllGouges",{},0,0],[[],"SelectPreviousGouge",{},0,0],[[],"SelectNextGouge",{},0,0],[[],"MoveToClearancePlane",{},0,0],[[],"GetNumberOfGouges",{R_:{num:''}},0,0],[[],"Reverse",{},0,0],[[],"Trim",{},0,0]],[]];
SPLM.CAM.ToolPathEditorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolPathEditorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.ToolPathEditorBuilder.MotionMethodType = Object.freeze({
    "Delta" : "Delta", "ToAPoint" : "ToAPoint"});

SPLM.CAM.ToolPathEditorBuilder.ExtendMethodType = Object.freeze({
    "Linear" : "Linear", "Arc" : "Arc", "LinearArc" : "LinearArc", "ArcLinear" : "ArcLinear", "LinearArcLinear" : "LinearArcLinear"});

SPLM.CAM.ToolPathEditorBuilder.ClearanceMethodType = Object.freeze({
    "Specify" : "Specify", "UseOperation" : "UseOperation"});

SPLM.CAM.ToolPathEditorBuilder.TrimMethod = Object.freeze({
    "Geometry" : "Geometry", "Path" : "Path"});

SPLM.CAM.ToolPathEditorBuilder.TrimPathType = Object.freeze({
    "Single" : "Single", "Range" : "Range", "BetweenRapids" : "BetweenRapids", "CutLevel" : "CutLevel", "NonCut" : "NonCut"});

SPLM.CAM.ToolPathEditorBuilder.TrimGeometryType = Object.freeze({
    "Plane" : "Plane", "LineInView" : "LineInView", "Boundary" : "Boundary", "PermanentBoundary" : "PermanentBoundary", "SelectionInView" : "SelectionInView"});

SPLM.CAM.ToolPathEditorBuilder.TrimSideType = Object.freeze({
    "Outside" : "Outside", "Inside" : "Inside"});

SPLM.CAM.ToolPathEditorBuilder.ConnectionMethodType = Object.freeze({
    "ClearancePlane" : "ClearancePlane", "Direct" : "Direct"});

export default SPLM;